 <ion-content class="ion-padding" [scrollY]="false">
  <form mode="md" (ngSubmit)="onSubmit()">
    <ion-text>
      <h1 class="ion-no-margin ion-margin-bottom font-text font-text--medium">Outro documento</h1>
      <p class="description-text description-text--extra-medium">Qual o nome do documento que você gostaria de enviar?</p>
    </ion-text>

    <form [formGroup]="form">
      <usucampeao-input label="Nome do documento" type="text" controlName="nome">
        <span usu-error>{{ gerarMensagemErro('nome', 'Nome do documento') }}</span>
      </usucampeao-input>
    </form>

    <ion-button id="busca-cpf" class="ion-margin-top" mode="md" expand="block" (click)="onSubmit()">Continuar</ion-button>
    <ion-button class="ion-margin-top" mode="md" expand="block" fill="outline" (click)="fecharModal()">Cancelar</ion-button>
  </form>
</ion-content>
